import React, { useState, useEffect, useContext } from 'react';
import './SettingsPage.css';
import bcrypt from 'bcryptjs';
import { message, Button, Switch } from 'antd';
import { AuthContext } from '../context/AuthContext';

function SettingsPage() {
  const [isAccountLockEnabled, setIsAccountLockEnabled] = useState(false);
  const [lockTime, setLockTime] = useState(30);
  const [passcode, setPasscode] = useState('');
  const [passcodeDisplay, setPasscodeDisplay] = useState('');
  const { setIsLocked } = useContext(AuthContext);

  useEffect(() => {
    const storedSettings = localStorage.getItem('settings');
    if (storedSettings) {
      const settings = JSON.parse(storedSettings);
      setIsAccountLockEnabled(settings.isAccountLockEnabled);
      setLockTime(settings.lockTime);
    }

    const storedPasscode = localStorage.getItem('passcode');
    if (storedPasscode) {
      setPasscodeDisplay('**********');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      'settings',
      JSON.stringify({
        isAccountLockEnabled: isAccountLockEnabled,
        lockTime: lockTime,
      })
    );
  }, [isAccountLockEnabled, lockTime]);

  const handleAccountLockToggle = (checked) => {
    setIsAccountLockEnabled(checked);
  };

  const handleLockTimeChange = (event) => {
    setLockTime(parseInt(event.target.value));
  };

  const handlePasscodeChange = (event) => {
    setPasscode(event.target.value);
  };

  const handleSavePasscode = async () => {
    if (passcode) {
      const salt = await bcrypt.genSalt(10);
      const hashedPassword = await bcrypt.hash(passcode, salt);
      localStorage.setItem('passcode', hashedPassword);
      message.success('Passcode saved successfully!');
      setPasscodeDisplay('**********');
      setPasscode('');
    } else {
      message.error('Please enter a passcode.');
    }
  };

  const handleLockNow = () => {
    setIsLocked(true);
  };

  return (
    <div className="settings-page">
      <h2>Settings</h2>

      <div className="setting-item">
        <label>
          Enable Lock:
          <Switch checked={isAccountLockEnabled} onChange={handleAccountLockToggle} />
        </label>
      </div>

      {isAccountLockEnabled && (
        <>
          <div className="setting-item">
            <label className={isAccountLockEnabled ? '' : 'disabled'}>
              Lock Time (minutes):
              <select
                value={lockTime}
                onChange={handleLockTimeChange}
                disabled={!isAccountLockEnabled}
              >
                <option value={15}>15</option>
                <option value={30}>30</option>
                <option value={60}>60</option>
                <option value={120}>120</option>
              </select>
            </label>
          </div>

          <div className="setting-item">
            <label className={isAccountLockEnabled ? '' : 'disabled'}>
              Set Local Passcode:
              <input
                type="password"
                value={passcode}
                placeholder={passcodeDisplay}
                onChange={handlePasscodeChange}
                disabled={!isAccountLockEnabled}
              />
              <Button
                type="primary"
                onClick={handleSavePasscode}
                disabled={!isAccountLockEnabled}
              >
                Save Passcode
              </Button>
            </label>
          </div>

          <div className="setting-item">
            <Button type="primary" onClick={handleLockNow}>
              Lock Now
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export default SettingsPage;
